import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TagsApiService {
  constructor(private http: HttpClient) {}

  getTags = (params: Record<string, string | number>) =>
    this.http.get('/api/v1.0/tags', {
      params,
    });
}
